// extracted by mini-css-extract-plugin
export default {"container":"MealCard_container__W7-Ei"};